






















import CMakeLogo from '~/components/shared/configurable/make/CMakeLogo.vue'
import { MakeLogoType } from '~/models/make'
import { defineComponent, PropType } from '~/utils/nuxt3-migration'
import { CategoryId } from '~/models/category/types'
import { ciCheckCircle } from '~/icons/source/light/check-circle'

export default defineComponent({
  components: { CMakeLogo },
  props: {
    arg: {
      type: Object,
      required: true
    },
    suggestionCategoryId: {
      type: Number as PropType<CategoryId>,
      required: true
    }
  },
  data() {
    return {}
  },
  computed: {
    hasMakeLogo() {
      return (
        [CategoryId.CARS, CategoryId.BIKES].includes(
          this.suggestionCategoryId
        ) &&
        this.arg.name === 'makemodel' &&
        this.arg.values.filter(a => a.type === 'make').length
      )
    },
    makeLogoType() {
      if (this.suggestionCategoryId === CategoryId.BIKES) {
        return MakeLogoType.BIKES
      }
      return MakeLogoType.CARS
    },
    isFreeText() {
      return ['mein', 'admin_mein', 'long_mein'].includes(this.arg.name)
    },
    argIcon() {
      if (['makemodel'].includes(this.arg.name)) {
        return null
      }

      return ciCheckCircle
    },
    makeLogoId() {
      if (this.hasMakeLogo) {
        return this.arg.values.filter(a => a.type === 'make')[0].value
      }
      return ''
    }
  }
})
